"use client";

/* eslint-disable array-callback-return */
import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import MenuItem from "component/react-bootstrap/MenuItem";
import SearchModalContext from "hooks-contexts/SearchModalContext";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import {
  forwardRef,
  memo,
  useContext, useEffect, useState,
} from "react";
import categoryMap from "resources/json/category-map.json";
import merchandiseJson from "resources/json/merchandise.json";
import regularServiceMap from "resources/json/regular-service.json";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import CloseButton from "../react-bootstrap/CloseButton";
import HoverNavDropdown from "./HoverNavDropdown";
import SubCategoriesContainer from "./SubCategoriesContainer";
import styles from "./toolbar_new.module.scss";

const Toolbar = forwardRef((props, ref) => {
  const { zIndexHandler } = props;
  const { t } = useTranslation("category-map");
  const [isLocaleLoaded, setIsLocaleLoaded] = useState(false);
  const [toolbarExpanded, setToolbarExpanded] = useState(false);
  const [show, setShow] = useState({ id: "", open: false });
  const { isSearchModalOpen } = useContext(SearchModalContext);
  const router = useRouter();
  const { asPath } = router;

  function onT0Click() {
    setIsLocaleLoaded(true);
  }

  function onUnmount() {
    setIsLocaleLoaded(false);
  }

  const closeToolbar = () => {
    // Focus out active toolbar when it's being closed
    const activeElement = document.getElementById(show.id);
    if (activeElement) {
      activeElement.blur();
    }
    setShow({ id: "", open: false });
    setToolbarExpanded(false);
  };

  function onToggle(val: boolean, id, event) {
    if (!show.id) {
      setToolbarExpanded(val);
    }

    if (val) {
      // Toolbar t1 hover popover was not completely visible on home page bcz login popover has more z-index for the first 5 seconds
      zIndexHandler(false, true);
    }

    if (show.open && id === show.id) {
      let toolBarMenu = null;
      Array.from(ref.current?.children[0].children, (liChild) => {
        if (liChild.className.includes("open")) {
          Array.from(liChild.children, (eachChild) => {
            if (eachChild.className.includes("dropdown-menu")) {
              toolBarMenu = eachChild;
            }
          });
        }
      });

      if ((ref.current && !toolBarMenu.contains(event.target))) {
        closeToolbar();
      }
    }
  }

  useEffect(() => {
    closeToolbar();
  }, [asPath]);

  useEffect(() => {
    // Focus out active element when we go from toolbar to any page bcz
    // toolbar remains focused & if we press down button on keyboard to scroll, it will not work
    const handleRouteChange = () => {
      const element = document.activeElement;
      if (element) element.blur();
    };

    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router]);

  const updatedJson = [regularServiceMap, ...categoryMap, ...merchandiseJson];
  return (
    <>
      {toolbarExpanded && (
        <div className={styles.overlay} />
      )}
      <div
        className={classNames(styles.toolbar_container, {
          [styles.search_modal_open]: isSearchModalOpen,
        })}
        ref={ref}
      >

        <ul className={`${styles.toolbar_nav} nav`}>
          {updatedJson
            .map((category: any, index: any) => {
              const {
                t0, sT0, sub, heading,
                images, brands,
              } = category;
              return (
                <HoverNavDropdown
                  key={sT0}
                  noCaret
                  id={`toolbar_cat_${index}`}
                  eventKey={index}
                  title={t(sT0)}
                  onToggle={onToggle}
                  setShow={setShow}
                  show={show}
                  ref={ref}
                  className={sT0 === "Merchandise" ? styles.success_blue_button : ""}
                >
                  <MenuItem>
                    <div className="d-flex flex-column" style={{ width: "100%" }}>
                      <PAText component="div" fontSize={FONT_SIZE[3]} className={styles.title} bold>
                        {t(t0 || heading)}
                        <CloseButton onClick={closeToolbar} />
                      </PAText>
                      <div className={styles.categories_and_image_container}>
                        <SubCategoriesContainer
                          {...{ sub, t0 }}
                          isLocaleLoaded={isLocaleLoaded}
                          onT0Click={onT0Click}
                          onUnmount={onUnmount}
                          closeToolbar={closeToolbar}
                          isRegularService={sT0 === "Regular Service"}
                          // className={sT0 === "Merchandise" ? styles.big_images_container : ""}
                        />
                        <div className="d-flex flex-column" style={{ gap: "calc(4 * var(--safari-root-font, 10px))" }}>
                          {images?.map((eachImage: string) => (
                            <div key={eachImage}>
                              <PAImage width={265} desktopHeight="calc(13.8 * var(--safari-root-font, 10px))" tabletHeight="calc(12 * var(--safari-root-font, 10px))" src={getRelativeImagePath(`/cms/${eachImage}`)} />
                            </div>
                          ))}
                        </div>

                      </div>
                      {/*    <HideIf show={brands && brands.length}>
                        <div>
                          <PAText fontSize={FONT_SIZE[3]} bold className={styles.brand_title}>
                            {t("Popular Brands")}
                          </PAText>
                          <div className={styles.brand_container}>
                            {brands?.slice(0, 8).map((brand: IManufacturerInfo) => (
                              <div key={brand.url} className={styles.brand}>
                                <SafeLink href={brand.url}>
                                  <a title={`Enhance Your Car with ${brand.manufacturer} Auto Parts`}>
                                    <div className={styles.logo_container}>
                                      <Image
                                        src={brand.manufacturerImageLogoUrl}
                                        alt={`Explore ${brand.manufacturer} Premium Automotive Components`}
                                        title={`Explore ${brand.manufacturer} Premium Automotive Components`}
                                        unoptimized
                                        layout="fill"
                                        objectFit="contain"
                                      />
                                    </div>
                                  </a>
                                </SafeLink>
                              </div>
                            ))}
                          </div>
                        </div>
                      </HideIf> */}

                    </div>
                  </MenuItem>

                </HoverNavDropdown>
              );
            })}

          {/* <PopularMakesDropdown
            onToggle={onToggle}
            heading={(
              <PAText component="div" fontSize={FONT_SIZE[3]} className={styles.title} bold>
                {t("Popular Makes")}
                <CloseButton onClick={closeToolbar} />
              </PAText>
            )}
            setShow={setShow}
            show={show}
            closeToolbar={closeToolbar}
          /> */}
        </ul>
      </div>
    </>
  );
});

Toolbar.displayName = "Toolbar";
export default memo(Toolbar);
